import React from "react";
import "../App.css";
import {
  Row,
  Col,
  Layout,
  Divider,
  Carousel,
  Layout as AntdLayout,
} from "antd";
import "antd/dist/antd.css";
import styled from "@emotion/styled";
import Footer from "../components/Footer";
import Header from "../components/Header";
import oranges from "../assets/oranges.jpg";
import citrus from "../assets/citrus.jpg";
import fourfruit from "../assets/fourfruit.jpg";
import fruitandvegetables from "../assets/fruitandvegetables.jpg";
import { HistoryOutlined, TeamOutlined, BarChartOutlined } from "@ant-design/icons";
import { IoEarth } from "react-icons/io5";

const Maintext = styled(AntdLayout.Content)({
  fontColor: "lightblack",
  textAlign: "center",
  fontSize: "20px",
  paddingLeft: "5%",
  paddingRight: "5%",
  paddingBottom: "3%",
  paddingTop: "4%",
});

const Headingtext = styled(AntdLayout.Content)({
  fontcolor: "lightblack",
  textAlign: "center",
  fontSize: "36px",
  paddingTop: "1%",
  fontWeight: "bold",
});
const CustomCarousel = styled(Carousel)({
  maxHeight: "700px",
  backgroundColor: "lightyellow",
  paddingTop: "1%",
  overflow: "hidden",
  "@media (min-width: 1600px)": {
    maxHeight: "1200px",
  },
  "@media (max-width: 1599px)": {
    maxHeight: "744px",
  },
  "@media (max-width: 992px)": {
    maxHeight: "744px",
  },
  "@media (max-width: 768px)": {
    maxHeight: "576x",
  },
  "@media (max-width: 576px)": {
    maxHeight: "432px",
  },
  "@media (max-width: 480px)": {
    maxHeight: "360px",
  },
  "@media (max-width: 320px)": {
    maxHeight: "240px",
  },
});
const CustomContent = styled(AntdLayout.Content)({
  backgroundColor: "lightyellow",
});

const Home: React.FC = (): JSX.Element => (
  <Layout>
    <Header />
    <CustomContent>
      <br/>
      <Headingtext>O nama</Headingtext>
      <CustomCarousel autoplay autoplaySpeed={4000}>
        <img src={fruitandvegetables} className="Fruitandveg" alt="logo" />
        <img src={fourfruit} className="fourfruit" alt="logo" />
        <img src={citrus} className="Citrus" alt="logo" />
        <img src={oranges} className="Orangen" alt="logo" />
      </CustomCarousel>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <Maintext>
            <HistoryOutlined
              style={{ fontSize: "50px", paddingBottom: "2%" }}
            />
            <br />
            Kika Holland je osnovana u septembru 2007 godine, a od juna 2008
            godine posluje u sastavu Milovan Miloševic Holdinga. U okviru istog
            Holdinga od 2013 godine posluje i kompanija Milbana Bv. Lična karta
            i sinonim naših aktivnosti vezan je za firmu Kika Holland, koja je
            sve ove godine motorna snaga razvoja naseg Holdinga u celini.
            <Divider />
            <TeamOutlined style={{ fontSize: "50px", paddingBottom: "2%" }} />
            <br />
            Osnivač i jedini vlasnik firme Kika Holland je Milovan Miloševic, u
            razgovoru za našu web stranicu ističe da se uspeh naše firme sastoji
            u samodisciplini, osmišljenom radu, kontinuitetu, istinskom
            poštovanju dobavljača i klijenata, kojima na kraju i dugujemo
            zahvalnost za objektivan uspeh koji je Kika Holland Bv postigla u
            ovom relativno kratkom vremenskom periodu.
            <Divider />
            <IoEarth style={{ fontSize: "77px", paddingBottom: "2%" }} />
            <br />
            Glavni fokus našeg poslovanja je usmeren na uvoz zelene banane iz:
            Ekvadora, Kostarike, Meksika, Hondurasa, Nikaragve i Kolumbije.
            Osnovni plasman se vrši na balkanskom tržištu, na kome je Kika
            Holland sasvim sigurno u samom vrhu po godišnjoj količini plasirane
            robe. Pored banane, ističemo i sada već tradicionalni uvoz citrusa
            iz Argentine i Južnoafričke Republike (period april-septembar svake
            godine). Utovari mešovitih artikala (voća i povrća) su takodje naša
            specijalnost, kojom se bavimo od samih početaka, i to pre nego što
            smo i ušli u biznis sa uvozom zelene banane.
            <Divider />
            <BarChartOutlined style={{ fontSize: "50px", paddingBottom: "2%" }} />
            <br />
            Strateško planiranje i praćenje sezonskih trendova u poslu voća i
            povrća, čini našu firmu različitom od ostalih u branši.
          </Maintext>
        </Col>
      </Row>
    </CustomContent>
    <Footer />
  </Layout>
);

export default Home;
